export function formatTitleWithSet(title, setNumber) {
  let cleanedTitle = title
  const prefixesToRemove = [
    'Progress Monitoring Assessment Collection: ',
    'Progress Monitoring Assessment: ',
    'Progress Monitoring Assessments: ',
    'Progress Monitoring Collection: '
  ]

  for (const prefix of prefixesToRemove) {
    if (cleanedTitle.startsWith(prefix)) {
      cleanedTitle = cleanedTitle.slice(prefix.length)
      break
    }
  }

  if (setNumber && setNumber !== 0) {
    return `${cleanedTitle} - Set ${setNumber}`
  }
  return cleanedTitle
}
